import {useDispatch} from 'react-redux';
import type {AppThunkDispatch} from '@jobseeker/common-core/stores';

const useAppDispatch = () => useDispatch<AppThunkDispatch>();

export default useAppDispatch;
